import styled from "styled-components";

const Paragraph = styled.p`
  color: ${(props) => props.theme.color.white};
`;

export default Paragraph;
